import React from 'react'
import {Container,Row,Col} from "react-bootstrap";
import FooterStore1 from "./asset/footerstore1.png"
import FooterStore2 from "./asset/footerstore2.png"
import {Link} from "react-router-dom";
import "../layout/Main.css"; 
import {FaFacebook,FaInstagram,FaWhatsapp} from "react-icons/fa";
const Footer = () => {
    return (
        <>
                      <footer id="footer" className="footer section">
                    <Container className="footer__container bd-grid">
                        <Row>
                            <Col  lg={4} md={4} xs={12} className="footer__box">
                                <h3 className="footer__title">CS</h3>
                                <p className="footer__deal">Product Store</p>
                                <a href="#"><img src={FooterStore1} alt="APP Store" className="footer__store"/>
                                </a>
                                <a href="#"><img src={FooterStore2} alt="APP Store" className="footer__store"/>
                                </a>
                            </Col>
                            <Col lg={4} md={4} xs={12}  className="footer__box">
                                <h3 className="footer__title">EXPLORE</h3>
                                <ul>
                                    <li><Link to="/" className="footer__link buttonComanderLinkef">ACCUEIL</Link></li>
                                    <li><Link to="/Woman" className="footer__link buttonComanderLinkef">ESPADRILLE</Link></li>
                                    <li><Link to="/Sabot" className="footer__link buttonComanderLinkef">SABOT</Link></li>
                                    <li><Link to="/Lunettes" className="footer__link buttonComanderLinkef">LUNETTES</Link></li>
                                </ul>
                            </Col>
                            <Col lg={4} md={4} xs={12}  className="footer__box">
                                <h3 className="footer__title">OUR Service</h3>
                                <ul>
                                    <li className="footer__link">Livraisons Gratuit</li>
                                    <li className="footer__link"> Support 24H/24H</li>
                                    <li className="footer__link">Boite Bien Luxueuse</li>
                                </ul>
                            </Col>

                            <Col lg={4} md={4} xs={12}  className="footer__box">
                                <h3 className="footer__title">FOLLOW</h3>
                                <ul>
                                <a href="https://www.facebook.com/Californie-Store-103974201835807" className="footer__social"><FaFacebook/></a>
                                <a href="https://www.instagram.com/californiestore/" className="footer__social"><FaInstagram/></a>
                                <a href="https://wa.me/212695911921?text=Hello" className="footer__social"><FaWhatsapp/></a>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                    <p className="footer__copy"> 2021  كل الحقوق محفوظة &#169;    </p>
            </footer>
        </>
    )
}

export default Footer
